import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import Select from 'react-select';
import { useFetch } from '../../../lib/useFetch';
import postObject from '../../../lib/postObject';
import { useForm } from '../../../lib/useForm';
import ImageUpload from '../../../components/imageUpload';

const CityCreateModal = ({ closeMainModal, reload }) => {
  const { data: countries, loading: countriesLoading } = useFetch(`countries`);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [photo, setPhoto] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');
  const [data, handleChange] = useForm({
    name: '',
    cityCode: '',
  });

  const validateForm = () => {
    if (!data.name) {
      setError('Please enter city name');
      return false;
    }
    if (!data.cityCode) {
      setError('Please enter city code');
      return false;
    }
    if (!selectedCountry) {
      setError('Please select a country');
      return false;
    }
    if (!photo) {
      setError('Please select a city photo');
      return false;
    }
    return true;
  };

  const saveCity = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);
      await postObject('cities', {
        ...data,
        countryId: selectedCountry.value,
        photo,
      });
      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to create city. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create City</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={closeMainModal}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={(e) => { e.preventDefault(); saveCity(); }}>
          <Form.Input
            name='name'
            label='Name'
            placeholder='Enter city name'
            value={data['name']}
            onChange={handleChange}
            required
          />

          <Form.Input
            name='cityCode'
            label='City Code'
            placeholder='Enter city code (ex. CAI, JED, RUH)'
            value={data['cityCode']}
            onChange={handleChange}
            required
          />

          <Form.Label>Country *</Form.Label>
          <Select
            isLoading={countriesLoading}
            value={selectedCountry}
            onChange={setSelectedCountry}
            options={countries && countries.map(country => {
              return ({ label: country.name, value: country['_id'] });
            })}
            placeholder="Select a country"
            isClearable
          />

          <ImageUpload
            label="City Photo"
            required
            uploadText="Click here to upload city photo"
            alt="City Preview"
            onChange={(value) => setPhoto(value)}
          />
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={saveCity}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={closeMainModal}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default CityCreateModal;
